export const useQuoteCalculator = (request: IRequest) => {
  const isArray = Array.isArray(request)
  let value: number | string = 0

  const calcBasePrice = (cost: number | string, item: Part) => {
    if (!item.numOfCharacteristics) {
      cost = 'TBD'
    } else if (item.numOfCharacteristics > 28) {
      cost = item.numOfCharacteristics * 55
    } else if (item.numOfCharacteristics <= 5) {
      cost = 700
    } else if (item.numOfCharacteristics <= 15) {
      cost = 1050
    } else if (item.numOfCharacteristics <= 28) {
      cost = 1400
    }

    return cost
  }

  const calcToleranceMultiplier = (cost: number, item: Part) => {
    switch (item.tolerance) {
      case '< 0.015mm (0.0005")':
        cost = cost * 1.5
        break
      case '< 0.500mm (0.020")':
        cost = cost * 1
        break
      case '> 0.500mm (0.020")':
        cost = cost * 1.15
        break
      default:
        break
    }

    return cost
  }

  const calcMaterialMultiplier = (cost: number, item: Part) => {
    switch (item.material) {
      case 'Plastic Molded':
        cost = cost * 1.15
        break

      case 'Glass/Plastic (transparent)':
        cost = cost * 1.05
        break

      default:
        break
    }

    return cost
  }

  const calcSizeMultiplier = (cost: number, item: Part) => {
    let xMultiplier = 1
    let yMultiplier = 1
    let zMultiplier = 1

    if (item.size) {
      if (item.size.units === 'inches') {
        if (!item.size.x) {
          xMultiplier = 1
        } else if (item.size.x < 3) {
          xMultiplier = 1.1
        } else if (item.size.x < 12) {
          xMultiplier = 1
        } else if (item.size.x < 24) {
          xMultiplier = 1.05
        } else if (item.size.x < 30) {
          xMultiplier = 1.1
        } else if (item.size.x < 45) {
          xMultiplier = 1.5
        } else {
          return 'TBD'
        }

        if (!item.size.y) {
          yMultiplier = 1
        } else if (item.size.y < 3) {
          yMultiplier = 1.1
        } else if (item.size.y < 12) {
          yMultiplier = 1
        } else if (item.size.y < 30) {
          yMultiplier = 1.05
        } else if (item.size.y < 48) {
          yMultiplier = 1.1
        } else if (item.size.y < 80) {
          yMultiplier = 1.5
        } else {
          return 'TBD'
        }

        if (!item.size.z) {
          zMultiplier = 1
        } else if (item.size.z < 3) {
          zMultiplier = 1.1
        } else if (item.size.z < 12) {
          zMultiplier = 1
        } else if (item.size.z < 24) {
          zMultiplier = 1.05
        } else if (item.size.z < 30) {
          zMultiplier = 1.1
        } else if (item.size.z < 36) {
          zMultiplier = 1.5
        } else {
          return 'TBD'
        }
      }

      if (item.size.units === 'mm') {
        if (!item.size.x) {
          xMultiplier = 1
        } else if (item.size.x < 75) {
          xMultiplier = 1.1
        } else if (item.size.x < 300) {
          xMultiplier = 1
        } else if (item.size.x < 600) {
          xMultiplier = 1.05
        } else if (item.size.x < 750) {
          xMultiplier = 1.1
        } else if (item.size.x < 1150) {
          xMultiplier = 1.5
        } else {
          return 'TBD'
        }

        if (!item.size.y) {
          yMultiplier = 1
        } else if (item.size.y < 75) {
          yMultiplier = 1.1
        } else if (item.size.y < 300) {
          yMultiplier = 1
        } else if (item.size.y < 750) {
          yMultiplier = 1.05
        } else if (item.size.y < 1200) {
          yMultiplier = 1.1
        } else if (item.size.y < 2000) {
          yMultiplier = 1.5
        } else {
          return 'TBD'
        }

        if (!item.size.z) {
          zMultiplier = 1
        } else if (item.size.z < 75) {
          zMultiplier = 1.1
        } else if (item.size.z < 300) {
          zMultiplier = 1
        } else if (item.size.z < 600) {
          zMultiplier = 1.05
        } else if (item.size.z < 750) {
          zMultiplier = 1.1
        } else if (item.size.z < 900) {
          zMultiplier = 1.5
        } else {
          return 'TBD'
        }
      }
    }

    cost = cost * Math.max(xMultiplier, yMultiplier, zMultiplier)

    return cost
  }

  const calcPartCost = (item: Part) => {
    let cost: string | number = 0

    cost = calcBasePrice(cost, item)
    cost = calcToleranceMultiplier(Number(cost), item)
    cost = calcMaterialMultiplier(cost, item)
    cost = calcSizeMultiplier(cost, item)

    return cost
  }

  const calcProgramCost = (program: Program, qty: number) => {
    let cost = 0

    cost = cost + 175 * program.runtime.hours
    cost = cost + (175 / 60) * program.runtime.minutes
    cost = cost * qty

    return cost
  }

  if (isArray) {
    for (let i = 0; i < request.length; i++) {
      if (request[i].type === 'inspection') {
        value = Number(value) + 700
        for (let j = 0; j < request[i].payload.length; j++) {
          value = value + calcProgramCost(request[i].payload[j], request[i].qty)
        }
      }

      if (request[i].type === 'programming') {
        value = Number(value) + Number(calcPartCost(request[i].payload))
      }

      if (request[i].type === 'incomplete') {
        value = 'TBD'
      }
    }
  } else {
    if (request.type === 'inspection') {
      value = 700

      if (Array.isArray(request.payload)) {
        request.payload.map(
          (x) => (value = Number(value) + calcProgramCost(x, request.payload.qty))
        )
      }
    }

    if (request.type === 'programming') {
      value = calcPartCost(request.payload as Part)
    }

  }

  return value
}
